import script from "./BudgetSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./BudgetSlider.vue?vue&type=script&setup=true&lang=ts"

import "./BudgetSlider.vue?vue&type=style&index=0&id=310c2b2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-310c2b2c"]])

export default __exports__